import React, { useCallback, useEffect, useState } from 'react'
import Layout from '../../layout/Layout'
import { Form } from 'react-bootstrap'
import MyEditor from '../../components/MyEditor'
import { useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../../utils/axiosConfig';
import * as CustomToast from '../../components/CustomToastMessage';

function FaqEdit() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        title: '',
        description: '',
    });
    const [loading, setLoading] = useState(false);

    const fetchTipDetails = useCallback(async () => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/faqs/${id}`);
            if (response.data.success) {
                const tip = response.data.data;
                setFormData({
                    title: tip.title,
                    description: tip.description,
                });
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        }
    }, [id])
    useEffect(() => {
        if (id) {
            fetchTipDetails();
        }
    }, [id, fetchTipDetails]);
    const handleSubmit = async () => {

        try {
            setLoading(true);
            const url = id
                ? `${process.env.REACT_APP_BACKEND_URL}/api/admin/faqs/edit/${id}`
                : `${process.env.REACT_APP_BACKEND_URL}/api/admin/faqs/create`;

            const method = id ? 'put' : 'post';

            const response = await axiosInstance({
                method,
                url,
                data: formData
            });

            if (response.data.success) {
                CustomToast.success(response.data.message);
                navigate('/faq');
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        } finally {
            setLoading(false);
        }
    };

    const handleEditorChange = (description) => {
        setFormData(prev => ({
            ...prev,
            description: description
        }));
    };

    return (
        <Layout title={id ? "Edit FAQ" : "Add FAQ"}>
            <main>
                <div className="card page-card">
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-12">
                                <Form.Group controlId="title">
                                    <Form.Label>Title</Form.Label>
                                    <Form.Control type="text" placeholder="Enter title" value={formData.title}
                                        onChange={(e) => setFormData(prev => ({
                                            ...prev,
                                            title: e.target.value
                                        }))} />
                                </Form.Group>
                            </div>
                            <div className="col-12">
                                <Form.Group controlId="Password">
                                    <Form.Label>Content</Form.Label>
                                </Form.Group>
                                <MyEditor
                                    htmlData={formData.description}
                                    setCourseAdd={(description) => {
                                        handleEditorChange(description);
                                    }}
                                />
                            </div>
                            <div className="col-12 d-flex justify-content-end gap-3">
                                <button className='btn-outline fs-16 fw-700 px-4' onClick={() => navigate('/faq')}>
                                    Cancel
                                </button>
                                <button
                                    className='btn-primary fs-16 fw-700 px-4'
                                    onClick={handleSubmit}
                                    disabled={loading}
                                    type="button"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    )
}

export default FaqEdit